export default [
  {
    path: '/login',
    name: 'Login',
    component: () => import('./pages/login/View.vue'),
  },
];
